<template>
	<b-container class="w-75 text-dark">
		<b-row class="heading mh-100 m-0 p-0" style="height: 100%; max-height: 100%;" align-v="center">
			<transition name="fade" key="transition.virtapp.index" appear>
			<b-col class="m-0 p-0 text-center">
				<template v-if="$asyncComputed.virtapps.updating && virtapps === null">
					<RingLoader :color="'#343a40'" :size="64" :loading="true" class="m-auto py-5" />
					Retrieving assigned stacks...
				</template>
				<template v-else-if="$asyncComputed.virtapps.success && virtapps">
					<Launch :stack="virtapp" v-if="doLaunch" />
					<AppList :stack="virtapp" v-else-if="displayBy === 'apps'" />
					<template v-else-if="virtapps.length">
						<b-card no-body v-if="virtapps.length" v-for="v in virtapps" v-bind:key="v.stackUUID" class="w-50 mb-1 mx-auto">
<!-- 
							<template v-slot:header>
								<h4 class="mb-0">{{ v.stackName }}</h4>
							</template>
 -->
							<b-card-footer class="m-0 p-0">
								<b-button class="block w-100" squared variant="primary" :to="{ name: 'Virtual Application Action', params: { action: 'launch', uuid: v.stackUUID } }">{{ v.stackName }}</b-button>
							</b-card-footer>
						</b-card>
					</template>
					<ErrorModal :modalData="{ message: 'We\'re sorry! You don\'t appear to have resources assigned. Please contact your school\'s help desk.', visible: true, allowClose: false }" v-else />
				</template>
			</b-col>
			</transition>
		</b-row>
	</b-container>
</template>

<script>
	import AppList from '@/components/VirtApp/AppList';
	import Launch from '@/components/VirtApp/Launch';
	import { RingLoader } from '@saeris/vue-spinners';
	
	export default
	{
		name: 'virtapp',
		props: [ 'action', 'uuid' ],
		components: { AppList, Launch, RingLoader },
		asyncComputed:
		{
			virtapps:
			{
				lazy: false,
				async get()
				{
					let virtapps = await this.portalAPI.get('/virtapp')
						.then(
							resp => resp.data,
							err => this.$logger.error(err)
						);
					
					virtapps.sort((a,b) => a.stackName.localeCompare(b.stackName));
					
					this.$logger.debug('User virtapps loaded', virtapps);
					
					return virtapps;
				}
			}
		},
		computed:
		{
			virtapp: function()
			{
				if(!this.virtapps || !this.uuid)
					return undefined;
				
				let uuid = this.uuid;
				
				if(this.$store.state.clientKey === '2AVQC2DRpOY8jvhHyQitWB' && uuid === 'default')
				{
					uuid = '2vO9ceHZ13t8zJYkrzWcxy';
				}
				
				return ((uuid === 'default') ? this.virtapps[0] : this.virtapps.filter(s => s.stackUUID === uuid)[0]);
			},
			portalAPI: function()
			{
				return this.$root.$refs.app.portalAPI;
			},
			doLaunch: function()
			{
				return Boolean(this.action === 'launch'
					&& this.uuid);
			},
			displayBy: function()
			{
				return (('display' in this.$route.query) ? this.$route.query.display : 'stacks');
			}
		},
		watch:
		{
		},
		methods:
		{
			getStack: function(uuid)
			{
				if(this.virtapps == undefined)
					return this.virtapps;
				
				let stack = (uuid === 'default') ? this.virtapps[0] : this.virtapps.filter(s => s.stackUUID === uuid)[0];
				
				return (stack && ('stackUUID' in stack)) ? stack.stackUUID : undefined;
			},
			showError: function(message) { return this.$root.$refs.app.showError(message); }
		},
		mounted()
		{
		},
		data() { return {}; }
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.container
	{
		height: 100%;
		max-height: 100%;
		
		overflow: auto;
		
		padding: 12px;
	}
	
	.fade-enter-active, .fade-leave-active
	{
		transition: all 1s;
	}
</style>
